import { setContext } from '@apollo/client/link/context';
import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';

import { ENV } from 'src/config/env';

export const httpLink = createHttpLink({
  uri: ENV.GRAPHQL_URL,
});

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem('accessToken');

  return {
    headers: {
      ...headers,
      authorization: token ? `JWT ${token}` : '',
    },
  };
});

export const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache({
    typePolicies: {
      // IDs identify a product/category, while these values belong to a specific
      // period, purchase position and metric. Keep each aggregate in its result.
      SalesProductKpiItemType: { keyFields: false },
    },
  }),
});
